module.exports = __webpack_public_path__ + "media/images/front/icons/arrow-right-hover-35da74568ad03f0f12c0eda871136b29.svg";